import axios from 'axios'
import { CURRENT_CONFIG } from './http/config'
import request, { IWorkspaceResponse } from '/@/api/http/request'

// DRC 链路
const API_PREFIX = '/screen/api/v1'

// 根据工作空间id获取设备类型统计数据
export const getDeviceTypeStatistics = async function (workspace_id: string, param: FormData): Promise<IWorkspaceResponse<any>> {
  const url = `${API_PREFIX}/devices/${workspace_id}/devices/statistics`
  const result = await request.post(url, param)
  return result.data
}

// 事件统计
export const getEventStatistics = async function (): Promise<IWorkspaceResponse<any>> {
  const url = `${API_PREFIX}/devices/event/stat-count`
  const result = await request.post(url)
  return result.data
}

export interface ScreenTimeParam {
  start_time: string;
  end_time: string;
  device_sn?: string;
}

// 任务数量统计
export const getTaskStatistics = async function (param: ScreenTimeParam): Promise<IWorkspaceResponse<any>> {
  const url = `${API_PREFIX}/devices/inspection/task/count`
  const result = await request.post(url, param)
  return result.data
}

// 事件数量统计
export const getEventCountStatistics = async function (param: ScreenTimeParam): Promise<IWorkspaceResponse<any>> {
  const url = `${API_PREFIX}/devices/inspection/event/count`
  const result = await request.post(url, param)
  return result.data
}

// 架次、时长、距离
export const getFlightStatistics = async function (param: ScreenTimeParam): Promise<IWorkspaceResponse<any>> {
  const url = `${API_PREFIX}/devices/inspection/stat/time-and-distance`
  const result = await request.post(url, param)
  return result.data
}

// 事件展示
export interface EventDataPageRequest {
    page: number
    page_size: number
    param: ScreenTimeParam
}

export interface EventDataRequest {
    alarm_message: string,
    algorithm_name: string,
    parent_device_sn: string,
    alarm_time: string
}

export const getEventData = async function (body: EventDataPageRequest): Promise<IWorkspaceResponse<any>> {
  const url = `${API_PREFIX}/devices/inspection/event/page`
  const result = await request.post(url, body)
  return result.data
}

// 任务状态统计
export const getTaskStat = async function (): Promise<IWorkspaceResponse<any>> {
  const url = `${API_PREFIX}/devices/task/task-status-count`
  const result = await request.get(url)
  return result.data
}

// 飞行轨迹
export const getFlightStat = async function (): Promise<IWorkspaceResponse<any>> {
  const url = `${API_PREFIX}/devices/flight-path-count`
  const result = await request.get(url)
  return result.data
}

// 人员、组织
export const getOrgStat = async function (): Promise<IWorkspaceResponse<any>> {
  const url = `${API_PREFIX}/devices/user-workspace-stat`
  const result = await request.get(url)
  return result.data
}

// 算法统计
export const getAthStat = async function (): Promise<IWorkspaceResponse<any>> {
  const url = `${API_PREFIX}/devices/inspection/algorithm-count`
  const result = await request.get(url)
  return result.data
}

// 任务阶段统计
export const getMonTaskStat = async function (): Promise<IWorkspaceResponse<any>> {
  const url = `${API_PREFIX}/devices/task-stat`
  const result = await request.get(url)
  return result.data
}

// 媒体列表
export interface MediaPageRequest {
  start_time: string
  end_time: string
  file_type: string
}

export interface MediaItem {
  url: string
}

export const getMediaDataList = async function (body: MediaPageRequest): Promise<IWorkspaceResponse<any>> {
  const url = `${API_PREFIX}/devices/inspection/media-list`
  const result = await request.post(url, body)
  return result.data
}

/** 高德地点信息 */
export function aMapSearch (params:{lng:number, lat:number}) {
  const url = `https://restapi.amap.com/v3/geocode/regeo?location=${params.lng},${params.lat}&key=${CURRENT_CONFIG.amapKey}`
  const result = axios.get(url)
  return result
}
